import request from '@/config/axios'

export interface WorkbenchNameValue {
  name: string
  value: number
}

export interface WorkbenchTrendItem {
  date: string
  label: string
  orderCount: number
  revenue: number
  newUserCount: number
}

export interface WorkbenchRankItem {
  name: string
  orderCount: number
  amount: number
  profitRate: number
}

export interface WorkbenchActivityItem {
  type: string
  title: string
  desc: string
  time: string
  amount?: number
}

export interface WorkbenchTodoItem {
  title: string
  desc: string
  priority: 'high' | 'medium' | 'low' | string
  path: string
}

export interface WorkbenchOverview {
  todayOrderCount: number
  todayRevenue: number
  weekNewUsers: number
  pendingRefundCount: number
  totalRevenue: number
  totalOrderCount: number
  totalTenantCount: number
  activeTenantCount: number
  adminUserCount: number
  domainCount: number
  activeModuleCount: number
  paidOrderCount: number
  paidAgentOrderCount: number
  paidModuleOrderCount: number
  completedRefundCount: number
  conversionRate: number
  refundRate: number
  targetCompletionRate: number
}

export interface WorkbenchStatistics {
  updatedAt: string
  overview: WorkbenchOverview
  dailyTrend: WorkbenchTrendItem[]
  orderStatus: WorkbenchNameValue[]
  moduleDistribution: WorkbenchNameValue[]
  moduleRank: WorkbenchRankItem[]
  activities: WorkbenchActivityItem[]
  todos: WorkbenchTodoItem[]
  regionRevenue: WorkbenchNameValue[]
  capability: WorkbenchNameValue[]
}

// 加载工作台统计数据(独立展示窗场景)
// 支持 period 参数,后端按时间周期(日/周/月/季度/年)返回数据
export const getWorkbenchStatistics = (period?: 'day' | 'week' | 'month' | 'quarter' | 'year') =>
  request.get<WorkbenchStatistics>({
    url: '/system/workbench/statistics',
    params: period ? { period } : undefined
  })
